type Ease = [number, number, number, number]

const easeValues = {
  in: [0.55, 0.06, 0.68, 0.19] as Ease,
  out: [0.22, 0.61, 0.36, 1] as Ease,
  inOut: [0.46, 0.03, 0.52, 0.96] as Ease,
}

export const theme = {
  colors: {
    background: '#191919',
    text: '#EAE5DF',
    textDark: '#343431',
    accent: {
      primary: '#7D161D',
      secondary: '#0F0F15',
      rfe: '#ea6903',
      tatari: (alpha = 1) => `rgba(150, 203, 196, ${alpha})`,
      komi: (alpha = 1) => `rgba(240, 186, 198, ${alpha})`,
      buryatiya: (alpha = 1) => `rgba(176, 187, 240, ${alpha})`,
      caxa: (alpha = 1) => `rgba(205, 223, 246, ${alpha})`,
    },
  },
  fonts: {
    base: '"Articulat CF", sans-serif',
    headings: '"Articulat CF", sans-serif',
  },
  easeValues,
  ease: Object.keys(easeValues).reduce(
    (acc, key) => ({
      ...acc,
      [key]: `cubic-bezier(${easeValues[key as keyof typeof easeValues].join(
        ', '
      )})`,
    }),
    { in: '', out: '', inOut: '' }
  ),
}
